import { render, staticRenderFns } from "./memberbalance-add-balance.vue?vue&type=template&id=304b6617&scoped=true&"
import script from "./memberbalance-add-balance.vue?vue&type=script&lang=js&"
export * from "./memberbalance-add-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b6617",
  null
  
)

export default component.exports